document.addEventListener("DOMContentLoaded", () => {
  let isMobile = false;
  let menuButton = null;
  let menu = null;
  let navItems = null;
  let isMenuOpen = false;
  let eventListenersAttached = false;

  function setIsMobile() {
    const wasMobile = isMobile;
    isMobile = window.innerWidth < 1024;

    if (wasMobile !== isMobile) {
      if (isMobile) {
        initializeMobileMenu();
      } else {
        cleanupMobileMenu();
      }
    }
  }

  function toggleMenu() {
    if (!menu) return;

    menu.classList.toggle("header__nav-wrapper--active");
    isMenuOpen = !isMenuOpen;
  }

  function initializeMobileMenu() {
    menuButton = document.getElementById("menu-btn");
    menu = document.getElementById("menu");
    navItems = document.querySelectorAll(".header__nav-item");

    if (menuButton && menu && !eventListenersAttached) {
      menuButton.addEventListener("click", toggleMenu);

      navItems.forEach((item) => {
        item.addEventListener("click", toggleMenu);
      });

      eventListenersAttached = true;
    }
  }

  function cleanupMobileMenu() {
    if (menu && menu.classList.contains("header__nav-wrapper--active")) {
      menu.classList.remove("header__nav-wrapper--active");
      isMenuOpen = false;
    }

    if (menuButton && eventListenersAttached) {
      menuButton.removeEventListener("click", toggleMenu);

      if (navItems) {
        navItems.forEach((item) => {
          item.removeEventListener("click", toggleMenu);
        });
      }

      eventListenersAttached = false;
    }
  }

  setIsMobile();

  window.addEventListener("resize", setIsMobile);
});
